<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white">
            <br/>
            <div class="row form-group">
                <label class="col-sm-4 col-form-label text-capitalize text-right">ชื่อเครื่อง</label>
                <div class="col-sm-4 col-form-label">
                    <input class="form-control" v-model="form.name"/>
                </div>
            </div>
            <div class="row form-group">
                <label class="col-sm-4 col-form-label text-capitalize text-right">คำอธิบายเครื่อง</label>
                <div class="col-sm-4 col-form-label">
                    <textarea class="form-control" v-model="form.description"></textarea>
                </div>
            </div>
            <!--<div class="row form-group">-->
                <!--<label class="col-sm-4 col-form-label text-capitalize text-right">เวลาในการผลิต / ช๊อต</label>-->
                <!--<div class="col-sm-4 col-form-label">-->
                    <!--<input type="number" class="form-control" v-model="form.time_shot"/>-->
                <!--</div>-->
                <!--<label class="col-sm-1 col-form-label">วินาที</label>-->
            <!--</div>-->
            <div class="col text-center">
                <button type="button" class="btn btn-success" @click="saveMachineProduct">
                    <icon name="save"></icon>
                    บันทึก
                </button>&nbsp;
                <button type="button" class="btn btn-outline-secondary" @click="goToMachineProductList">
                    <icon name="times"></icon>
                    ยกเลิก
                </button>&nbsp;
                <button type="button" class="btn btn-danger"
                        @click="showModalDelete"
                        v-if="form.id">
                    <icon name="trash"></icon>
                    ลบ
                </button>&nbsp;
            </div>
            <br/>
            <!-- Modal Delete-->
            <b-modal hide-header hide-footer ref="delete_item">
                <div style="text-align: center;">
                    <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                    <br />
                    <button @click="deleteMachineProduct"
                            type="button"
                            class="btn btn-success">
                        ตกลง
                    </button>
                    &nbsp&nbsp
                    <button @click="hideModalDelete"
                            type="button"
                            class="btn btn-secondary">
                        ยกเลิก
                    </button>
                </div>
            </b-modal>
        </div>
        <!--<pre class="alert-primary">{{form}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";

    export default {
        name: "machine-product-form",
        data(){
            return{
                items: [
                    {
                        text: "รายการเครื่องขึ้นรูป",
                        to: {name: "machine-product"}
                    },
                    {
                        text: "เพิ่มเติม",
                        active: true
                    }
                ],
            }
        },
        computed:{
            ...mapState({
                form :state=>{
                    return state.MachineProduct.form;
                }
            })
        },
        methods:{
            //Modal
            showModalDelete() {
                this.$refs.delete_item.show();
            },
            hideModalDelete() {
                this.$refs.delete_item.hide();
            },

            //API
            saveMachineProduct(){
                this.$store.dispatch("MachineProduct/saveMachine",this.form.id).then(()=>{
                    this.goToMachineProductList();
                })
            },
            goToMachineProductList(){
                this.$router.push("/machine-product")
            },
            deleteMachineProduct(){
                this.$store.dispatch("MachineProduct/deleteMachine",this.form.id).then(()=>{
                    this.hideModalDelete();
                    this.$store.dispatch("MachineProduct/getMachine")
                    this.goToMachineProductList();
                })
            }
        }
    }
</script>

<style scoped>

</style>